import { declaredId, declaresOptions } from './declaration-paths';
/**
 * An architecture always contains every relationship a pattern declares in prefixItems, so
 * a decision declared there is always asked. An items member may be left out, so a
 * decision declared there can vanish, and declining it stops being a choice.
 */
export function decisionIsDeclaredInPrefixItems(input, _, context) {
    const relationship = input;
    if (!relationship || !declaresOptions(relationship)) {
        return [];
    }
    return [{
            message: `The decision '${declaredId(relationship) ?? 'unknown'}' is declared in items. Declare a decision in relationships prefixItems, so that an answer can decline it.`,
            path: [...context.path],
        }];
}
//# sourceMappingURL=decision-is-declared-in-prefix-items.js.map